const keyWordsKey = 'd2-group-default-keywords'
import defaultKeyWords from '@/view/d2/key-words'

export function getKeyWords() {
  const item = window.localStorage.getItem(keyWordsKey)
  if (item) {
    return JSON.parse(item)
  } else {
    return undefined
  }
}

export function setKeyWords(list) {
  window.localStorage.setItem(keyWordsKey, JSON.stringify(list))
}
export function initKeyWords() {
  window.localStorage.setItem(keyWordsKey, JSON.stringify(defaultKeyWords))
  return defaultKeyWords
}

